import { LoanSummary } from "components/YourBBLS/LoanSummary";
import { LoanDetails } from "domain/yourBBLS";
import { Accordion } from "../common/Accordion";

export type LoanSummaryAccordionProps = {
  loanDetails: LoanDetails;
};

export const LoanSummaryAccordion = ({
  loanDetails,
}: LoanSummaryAccordionProps) => {
  return (
    <div className="appSummary">
      <Accordion header="Loan summary">
        <LoanSummary loanDetails={loanDetails} className="app-loan-summary" />
      </Accordion>
    </div>
  );
};
